/* Presentation only: the MW app retains ownership of bundle state and checkout. */
(() => {
  if (customElements.get('sippy-bundle-subheading')) return;

  customElements.define('sippy-bundle-subheading', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section');
      if (!this.scope || !this.dataset.text || !this.dataset.title) return;
      this.roots = new Map();
      this.deadline = Date.now() + 30000;
      this.sectionObserver = new MutationObserver(() => this.connectRoots());
      this.sectionObserver.observe(this.scope, { childList: true, subtree: true });
      this.connectRoots();
    }

    connectRoots() {
      clearTimeout(this.retry);
      if (!this.isConnected) return;
      for (const [host, observer] of this.roots) {
        if (!this.scope.contains(host)) {
          observer.disconnect();
          this.roots.delete(host);
        }
      }
      const hosts = [...this.scope.querySelectorAll('mw-build-offer')];
      let waiting = hosts.length === 0;
      for (const host of hosts) {
        // MW attaches its open shadow root asynchronously after its helpers load.
        if (!host.shadowRoot) {
          waiting = true;
          continue;
        }
        if (this.roots.has(host)) continue;
        const root = host.shadowRoot;
        const observer = new MutationObserver(() => this.renderSubheading(root));
        observer.observe(root, { childList: true, subtree: true, characterData: true });
        this.roots.set(host, observer);
        this.renderSubheading(root);
      }
      if (waiting && Date.now() < this.deadline) {
        this.retry = setTimeout(() => this.connectRoots(), 100);
      }
    }

    renderSubheading(root) {
      const normalize = (text) => text.trim().replace(/\s+/g, ' ').toLowerCase();
      const title = [...root.querySelectorAll('h1.Products-Category__CategoryTitle')]
        .find((heading) => normalize(heading.textContent) === normalize(this.dataset.title));
      const container = title?.closest('.Products-Category__CategoryTitleContainer');
      if (!container) return;
      let paragraph = container.nextElementSibling;
      if (!paragraph?.hasAttribute('data-sippy-bundle-subheading')) {
        paragraph = document.createElement('p');
        paragraph.setAttribute('data-sippy-bundle-subheading', '');
        // The app header already stacks children vertically with an 8px gap.
        paragraph.style.cssText = 'margin:0;font-family:var(--mw-build-offer-font-family);font-size:var(--body-font-size,16px);font-weight:400;line-height:1.5;color:var(--mw-build-offer-text-primary-color);overflow-wrap:anywhere;';
        container.after(paragraph);
      }
      if (paragraph.textContent !== this.dataset.text) {
        paragraph.textContent = this.dataset.text;
      }
    }

    disconnectedCallback() {
      clearTimeout(this.retry);
      this.sectionObserver?.disconnect();
      this.roots?.forEach((observer) => observer.disconnect());
      this.roots?.clear();
    }
  });
})();
